export default "__VITE_ASSET__Cfzj$XHd__";